import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

const ChatButton = ({ onClick }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Pulse animation every 3 seconds
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 1000);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <button
      onClick={onClick}
      className={`fixed bottom-6 right-6 z-40 bg-gradient-to-r from-blue-600 to-blue-500 text-white p-4 rounded-full shadow-2xl hover:shadow-blue-300 hover:scale-110 transition-all duration-300 ${
        isAnimating ? 'animate-pulse' : ''
      }`}
      aria-label="Open chat"
    >
      <MessageCircle size={28} />
      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-6 h-6 rounded-full flex items-center justify-center font-bold animate-bounce">
        24/7
      </span>
    </button>
  );
};

export default ChatButton;
